import { Directive } from '@angular/core';
import { BaseComponent } from '@vivela/xplat/core';

@Directive()
export abstract class SelectOptionsBaseComponent extends BaseComponent {}
